module.exports = __webpack_public_path__ + "img/appTableNoData.7801010.png";